import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"min-width":"800px","width":"60%"}
}
const _hoisted_2 = {
  key: 0,
  class: "icon",
  "aria-hidden": "true",
  "font-size": "20px"
}
const _hoisted_3 = ["xlink:href"]
const _hoisted_4 = { class: "dataForm" }
const _hoisted_5 = { class: "dialog-footer mt-20" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_ZUpload = _resolveComponent("ZUpload")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_ctx.detail)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_el_descriptions, { title: "业务详情" }, {
          title: _withCtx(() => [
            _cache[5] || (_cache[5] = _createElementVNode("span", null, "业务详情", -1)),
            (_ctx.detail.urgentIcon)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_2, [
                  _createElementVNode("use", {
                    "xlink:href": '#' + _ctx.detail.urgentIcon
                  }, null, 8, _hoisted_3)
                ]))
              : _createCommentVNode("", true)
          ]),
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnAllData, (item, index) => {
              return (_openBlock(), _createBlock(_component_el_descriptions_item, {
                label: item.fieldName + '：',
                key: index
              }, {
                default: _withCtx(() => [
                  (item.fieldKey === 'repairTimes')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.detail[item.fieldKey] || 0), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(_ctx.detail[item.fieldKey]), 1)
                      ], 64))
                ]),
                _: 2
              }, 1032, ["label"]))
            }), 128))
          ]),
          _: 1
        }),
        _createVNode(_component_el_descriptions, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_descriptions_item, { label: "外观图片：" }, {
              default: _withCtx(() => [
                (_ctx.detail.appearancePictures && _ctx.detail.appearancePictures.length)
                  ? (_openBlock(), _createBlock(_component_ZUpload, {
                      key: 0,
                      onChanged: _ctx.handlePictures,
                      value: _ctx.detail.appearancePictures || [],
                      option: { config: {} },
                      canUpload: false
                    }, null, 8, ["onChanged", "value"]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(" 无 ")
                    ], 64))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_form, {
            ref: "dataForm",
            model: _ctx.ruleForm,
            rules: _ctx.rules,
            "label-width": "100px",
            class: "mb-20"
          }, {
            default: _withCtx(() => [
              (_ctx.detail.repairType !== 1)
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 0,
                    label: "是否完成",
                    prop: "complete"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_switch, {
                        modelValue: _ctx.ruleForm.complete,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.ruleForm.complete) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.detail.type === 2)
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 1,
                    label: "产品说明书",
                    prop: "productDes"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ZUpload, {
                        onChanged: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleUploadChange($event, 'productDes'))),
                        value: _ctx.ruleForm.productDes,
                        option: { config: {} }
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createVNode(_component_el_form_item, {
                      label: "检测情况",
                      prop: "checkDes"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.ruleForm.checkDes,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.ruleForm.checkDes) = $event)),
                          type: "textarea",
                          clearable: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "更换配件",
                      prop: "changeParts"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.ruleForm.changeParts,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.ruleForm.changeParts) = $event)),
                          type: "textarea",
                          clearable: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "检查图片",
                      prop: "checkPictures"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ZUpload, {
                          onChanged: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleUploadChange($event, 'checkPictures'))),
                          value: _ctx.ruleForm.checkPictures,
                          option: { config: {} }
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ], 64))
            ]),
            _: 1
          }, 8, ["model", "rules"]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_button, { onClick: _ctx.cancle }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("table.cancel")), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, {
              type: "primary",
              loading: _ctx.submitLoading,
              onClick: _ctx.handleSubmit
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("table.confirm")), 1)
              ]),
              _: 1
            }, 8, ["loading", "onClick"])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}